window.registerExpandElements = function(){
    document.querySelectorAll('.expand').forEach(button => {
        button.addEventListener('click', event => {
            // Find an element at the same level with a class of 'expandable'
            let expandable = button.parentElement.querySelector('.expandable');
            // Set a class of 'expanded' on the element
            expandable.classList.toggle('expanded');
            // Remove the button
            button.remove();
        });
    });
}

window.registerExpandElements();
